module.exports = __webpack_public_path__ + "static/media/storeAddress.17204c57.svg";